/**
 * Enum for user devices.
 */
export const UserDevice = {
    /** Mobile */
    MOBILE: 'mobile',
    /** Tablet */
    TABLET: 'tablet',
    /** Desktop */
    DESKTOP: 'desktop',
};
